import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords = '',
  ogImage = 'https://customer-assets.emergentagent.com/job_83f58cf4-8845-4128-a505-0ed372481ec0/artifacts/3c96zr88_logo.jpg'
}) => {
  const location = useLocation();
  const baseUrl = 'https://tekclap.com';
  const defaultDescription = 'TekClap is a technology, AI, and product consulting firm helping organizations modernize platforms, build intelligent products, and scale teams effectively.';
  
  const fullTitle = title ? `${title} | TekClap` : 'TekClap | Technology, AI & Product Consulting';
  const metaDescription = description || defaultDescription;
  const canonicalUrl = `${baseUrl}${location.pathname}`;

  useEffect(() => {
    // Update title
    document.title = fullTitle;
    
    // Update meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    // Primary Meta Tags
    updateMetaTag('title', fullTitle);
    updateMetaTag('description', metaDescription);
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }
    
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', canonicalUrl);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', canonicalUrl);
      document.head.appendChild(canonical);
    }
    
    // Open Graph
    updateMetaTag('og:title', fullTitle, true);
    updateMetaTag('og:description', metaDescription, true);
    updateMetaTag('og:url', canonicalUrl, true);
    updateMetaTag('og:image', ogImage, true);
    
    // Twitter
    updateMetaTag('twitter:title', fullTitle);
    updateMetaTag('twitter:description', metaDescription);
    updateMetaTag('twitter:url', canonicalUrl);
    updateMetaTag('twitter:image', ogImage);
    
  }, [fullTitle, metaDescription, canonicalUrl, keywords, ogImage]);

  return null;
};

export default SEO;
